import Vue from 'vue'
import LdDownloadComponent from './index.vue'

const LdDownloadConstructor = Vue.extend(LdDownloadComponent) // 直接将Vue组件作为Vue.extend的参数

let seed = 1
let instance

const LdDownload = (options) => {
  if (Vue.prototype.$isServer) return
  options = options || {}

  instance = new LdDownloadConstructor({
    propsData: options
  })

  instance.domId = `LdDownload${seed}`
  instance.vm = instance.$mount()
  instance.vm.visible = true
  instance.dom = instance.vm.$el
  document.body.appendChild(instance.dom)
  return instance.vm
}

LdDownload.install = (Vue) => {
  Vue.component(LdDownload.name, LdDownload)

  Vue.prototype.$LdDownload = LdDownload
}

export default LdDownload